/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkReportListFilter {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkReportListFilter.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkReportListFilter>): WellArchitectedFrameworkReportListFilter {
        let obj = Object.assign(new WellArchitectedFrameworkReportListFilter(), model);
        WellArchitectedFrameworkReportListFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkReportListFilter>): WellArchitectedFrameworkReportListFilter {
        if (!model) return null;
        return WellArchitectedFrameworkReportListFilter.newInstance(<WellArchitectedFrameworkReportListFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkReportListFilter) {
        if (!obj) return;

        models.WellArchitectedFrameworkReportListFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkReportListFilter): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkReportListFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.time_delta_in_days === undefined) {
            this.time_delta_in_days = 0;
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Time delta to filter reports created in the last N days
     */
    time_delta_in_days: number;

    filters: models.QueryOperator;

}
